import { browser } from '$app/environment';

let audio: HTMLAudioElement | null = null;
let soundTimeout: number | null = null;

// Load sound preference from localStorage
const loadSoundPreference = (): boolean => {
    if (!browser) return true;
    const saved = localStorage.getItem('soundEnabled');
    return saved === null ? true : saved === 'true';
};

// Store sound preference
export const storeSoundPreference = (enabled: boolean) => {
    if (!browser) return;
    localStorage.setItem('soundEnabled', enabled.toString());
};

export const isSoundEnabled = loadSoundPreference();

export function playTimerSound(duration: number = 5000) {
    if (!browser || !isSoundEnabled) return;

    // Create audio element if it doesn't exist
    if (!audio) {
        audio = new Audio('/alarm.mp3');
        audio.loop = true;
    }

    // Play the sound
    audio.play().catch(error => {
        console.error('Error playing sound:', error);
    });

    // Stop the sound after the specified duration
    if (soundTimeout) {
        clearTimeout(soundTimeout);
    }
    soundTimeout = window.setTimeout(() => {
        if (audio) {
            audio.pause();
            audio.currentTime = 0;
        }
    }, duration);
}

export function stopTimerSound() {
    if (!browser || !audio) return;

    audio.pause();
    audio.currentTime = 0;
    if (soundTimeout) {
        clearTimeout(soundTimeout);
        soundTimeout = null;
    }
} 